import React, { useRef } from "react";
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { formatTableExportData, getDefaultTableColumnDef } from "../myspace/providers/stats/sales/StatsSalesTableColumnsDef.jsx";
import { setXlsxColumnFormat, truncateString } from "../../utils.js";
import * as XLSX from 'xlsx';

let cancelToken = axios.CancelToken.source();

export default function ButtonDownloadExtract(props) {
    const buttonRef = useRef(null)
    const { t: gctrad } = useTranslation();

    const exportXLSX = (filename, data) => {
        const title = formatXlsExportFilename(currentSociete.nom, filename);
        let worksheet_title_str = title.split('-').slice(-1).toString();
        const worksheet_title = truncateString(worksheet_title_str, 31, ''); // Max 31 characters !
        const worksheet = XLSX.utils.json_to_sheet(data.exportData);
        if (Object.keys(data.columnFormat.date_with_hours ?? {}).length) {
            setXlsxColumnFormat(worksheet, data.columnFormat.date_with_hours, getDateFormatString(true));  // date with hours
        }
        if (Object.keys(data.columnFormat.date_only ?? {}).length) {
            setXlsxColumnFormat(worksheet, data.columnFormat.date_only, getDateFormatString());  // date only
        }
        if (Object.keys(data.columnFormat.int ?? {}).length) {
            setXlsxColumnFormat(worksheet, data.columnFormat.int, '0');  // int
        }
        if (Object.keys(data.columnFormat.float).length ?? {}) {
            setXlsxColumnFormat(worksheet, data.columnFormat.float);  // float
        }
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, worksheet_title);
        XLSX.writeFile(workbook, title + ".xlsx");
    }

    const handleClick = async () => {
        buttonRef.current.blur(); // removing focus
        $('#download_extract').modal('hide');
        nav.wait({ display: true, 'delay': 100, 'text': gctrad('[:myspace] Génération du fichier d export en cours') });
		try {
			const result = await axios.get(ENV.api_backyou.url + "stats/sales", { 
				params: {
                    'categorie': 'all',
                    'products_orders_type': 'all',
                    'customers_views': 'all',
                    'with_accommodations': 'all',
                    'with_meeting_rooms': 'all',
                    'with_function_sheets': 'all',
                    'pagination': false
                },
				headers: { 
					"accept": "application/json",
					"X-AUTH-TOKEN": ENV.api_backyou.key,
					"MUID": membres_uid,
					"SUID": societes_uid,
					"lang": ENV.lang
				},
				cancelToken: cancelToken.token
			});
            const columnDef = getDefaultTableColumnDef();
			const formatExport = formatTableExportData(columnDef, result.data);
			nav.wait(false);
			return exportXLSX(gctrad('Dossiers'), formatExport);
		}
		catch (error) {
			nav.wait(false);
			nav.infos_error(gctrad('myspace Une erreur est survenue'));
			throw new Error(error);
		}
    };

    return (
        <>
            <button 
                ref={buttonRef}
                className="btn btn-sm btn-orange float-right text-white font-weight-bold"
                onClick={handleClick}
            >
                <i className="fas fa-download"></i>
            </button>
        </>
    );
}